import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from '../../shared/state/signal-entity.store';

export interface UnderwriterState extends EntityState<any> { }

@Injectable({ providedIn: 'root' })
export class UnderwriterStore extends SignalEntityStore<any, UnderwriterState> {
  constructor() {
    super({name: 'underwriter', idKey: 'index'});
  }
}
